import { backend_url, uninterceptedAxiosInstance, qs } from "../common/commonVariables";

export const updateUserNotificationToken = async (
  id,
  token,
  language = "English",
  mainToken = false
) => {
  try {
    let params = {
      webFcmToken: token,
      language,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "users/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {

    if (err.response) {
     
    } else if (err.request) {

    } else {
      
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const markNotificationAsRead = async (id) => {
  try {
    const response = await uninterceptedAxiosInstance.put(
      backend_url + `notifications/${id}`,
      {
        data: {
          isRead: true,
        },
      },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};


export const markAllNotificationAsRead = async () => {
  try {
    const response = await uninterceptedAxiosInstance.post(
      backend_url + `notification/mark-all-as-read`,
      {
        data: {
          isRead: true,
        },
      },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};



export const getNotifications = async (id) => {
  const query = qs.stringify(
    {
      sort: ["createdAt:desc"],
      filters: {
        $and: [
          {
            user: {
              id: {
                $eq: id,
              },
            },
          },
        ],
      },
      populate: [
        "asset",
        "organisation",
        "part",
        "user",
        "user.sendByUser",
        "sendByUser",
        "workOrder",
        "purchaseOrder",
        "purchaseOrder.approvedByUser",
        "purchaseOrder",
        "purchaseOrder.details",
        "purchaseOrder.details.vendor",
        "sets",
        "workRequest",
        "workRequest.submittedBy",
        "workRequest.updatedByUser",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `notifications?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};